var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockWindowsNotifyBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "27px",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "block_Windows_notify_icon",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6207001,10 L28,24.7587546 C28,25.1015151 27.8669476,25.4118264 27.651831,25.6364477 C27.4367144,25.8610689 27.1395335,26 26.8112766,26 L26.8112766,26 L1.18872343,26 C0.860466525,26 0.563285667,25.8610689 0.348169033,25.6364477 C0.133052399,25.4118264 0,25.1015151 0,24.7587546 L0,24.7587546 L0,11.2412454 C0,10.898485 0.133052399,10.5881736 0.348169033,10.3635524 C0.563285667,10.1389311 0.860466525,10 1.18872343,10 L1.18872343,10 L27.6207001,10 Z",
    id: "Rectangle",
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    transform: "translate(7.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/social/notifications_none_24px",
    fill: "#AD4F4F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,21 C10.80625,21 11.875,20.0307692 11.875,18.8461539 L7.125,18.8461539 C7.125,20.0307692 8.19375,21 9.5,21 Z M3.02272727,5.21328671 C2.24536649,6.36023477 2.375,7.62631086 2.375,9.15384615 L2.375,14.5384616 L0,16.6923077 L0,17.7692308 L19,17.7692308 L19,16.6923077 C8.41852256,9.13475445 3.09276499,5.30841412 3.02272727,5.21328671 Z M16.625,12.8496503 C16.625,12.0283605 16.625,10.7964258 16.625,9.15384615 C16.625,5.8476923 14.689375,3.08 11.28125,2.34769231 L11.28125,1.61538462 C11.28125,0.721538461 10.485625,0 9.5,0 C8.514375,0 7.71875,0.721538461 7.71875,1.61538462 L7.71875,2.34769231 C6.4515818,2.6209222 5.38609353,3.17599802 4.54819036,3.93684731",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.071429, -2.470588)",
    id: "\\u21B3-Tonal-Palette"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    fill: "#333",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 28.5,
    height: 25.9411765
  })))))), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 3,
    x2: 26,
    y2: 18,
    id: "Path-8",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockWindowsNotifyBlack);
export default __webpack_public_path__ + "static/media/block_Windows_notify_black.93e1cb750765225569ef4d1d7138c4cb.svg";
export { ForwardRef as ReactComponent };